import React from "react";
import DataArea from "../DataArea/index.js";
import "./Main.css";

function Main (){
    return (
        <>
        <DataArea />
        </>
    );
};

export default Main;